import { all, call } from "redux-saga/effects";
import { leaderboardSagas } from "./leaderboard/leaderboard.saga";
import { quizSagas } from "./quiz/quiz.saga";
import { userSagas } from "./user/user.saga";

export function* rootSaga() {
  yield all([call(userSagas),call(quizSagas),call(leaderboardSagas)]);
}
